module.exports = __webpack_public_path__ + "img/sardinia.5ab6fd16.svg";